import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useRole(roleId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["roles", roleId ?? null],
		queryFn: async () => {
			if (!roleId) throw new Error("Role ID is required");
			const response = await client.roles[":roleId"].$get({ param: { roleId } });
			const data = await responseHandler(response);
			return data.role;
		},
		enabled: !!roleId,
	});

	/** Return */
	return { ...query, role: query.data };
}
